import React from 'react';
import { CircularProgress, withStyles, useTheme } from '@material-ui/core';

const Spinner = ({ colour = 'secondary', size = '4rem', variant, value }) => {
  const { palette } = useTheme();
  const Circle = withStyles({
    root: {
      color: colour === 'text' ? palette.text.primary : palette[colour].main,
    },
  })(CircularProgress);
  return <Circle size={size} variant={variant} value={value} />;
};

export default Spinner;
